module.exports = __webpack_public_path__ + "img/favorite-remove.6fa7daea.svg";